<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaOrgSelect',
})
</script>
<!--
 * @Author: honghuipu 1633390759@qq.com
 * @Date: 2026-09-20 14:08:00
 * @LastEditors: honghuipu 1633390759@qq.com
 * @LastEditTime: 2026-10-23 08:37:09
 * @FilePath: \phm3-admin123\src\components\ma-org\ma-org-select\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-tree-select
		v-model="model"
		:data="orgList"
		value-key="id"
		:check-strictly="checkStrictly"
		:render-after-expand="false"
		:props="{ label: 'name', children: 'children' }"
		style="width: 100%"
		filterable
		:clearable="clearable"
		:placeholder="placeholder"
		:disabled="disabled"
	/>
</template>

<script setup lang="ts" name="MaOrgSelect">
import { ref } from 'vue'
import { useOrgListApi } from '@/api/sys/orgs'

defineProps({
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	},
	checkStrictly: {
		type: Boolean,
		default: true
	}
})

const model = defineModel<any>()
const orgList = ref([])

// 获取机构列表
const getOrgList = async () => {
	const res = await useOrgListApi()
	orgList.value = res.data
}

getOrgList()
</script>
